var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"background"},[_c('div',{staticClass:"spinner-border spinner"})])])
}]

export { render, staticRenderFns }